import { render, staticRenderFns } from "./WorkCenterSelect.vue?vue&type=template&id=231d688c&"
import script from "./WorkCenterSelect.vue?vue&type=script&lang=js&"
export * from "./WorkCenterSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports